import { NativeBaseProvider, Text, Slide, CloseIcon, IconButton, Collapse, Alert, useToast, Box, Center, Heading, VStack, FormControl, Input, Link, Button, HStack, } from "native-base";
import { TouchableOpacity } from "react-native";
import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import AsyncStorage from '@react-native-async-storage/async-storage';

export default function Register({ navigation }) {
    const [formData, setData] = React.useState({});
    const [errors, setErrors] = React.useState("");
    const [show, setShow] = React.useState(false);


    function singUp() {
        axios
            .get("https://birdra1n.x10.bz/AuthMail/signUP/", {
                params: {
                    username: formData.username,
                    password: formData.password,
                    email: formData.email,
                    name: formData.name
                },
            })
            .then(function (response) {
                var req = response.data;
                if (req.error == undefined) {
                    alert(req.success)
                    navigation.navigate('home');
                } else {
                    setErrors(req.error);
                    setShow(true)
                    setTimeout(() => {
                        setShow(false);
                    }, 3000);
                }
            });
    }


    return (
        <NativeBaseProvider>
            <Slide in={show} placement="top">
                <Alert justifyContent="center" status="error">
                    <Alert.Icon />
                    <Text color="error.600" fontWeight="medium">
                        {errors}
                    </Text>
                </Alert>
            </Slide>
            <Box safeArea w={'100%'} h={'100%'} bg={'white'}>


                <Center top={-32}>
                    <Box safeArea p="2" py="8" w="90%" maxW="290">
                        <Heading size="lg" fontWeight="600" color="coolGray.800" _dark={{
                            color: "warmGray.50"
                        }}>
                            AuthEmailPHP
                        </Heading>
                        <Heading mt="1" _dark={{
                            color: "warmGray.200"
                        }} color="coolGray.600" fontWeight="medium" size="xs">
                            Create an account to continue!
                        </Heading>

                        <VStack space={3} mt="5">
                            <FormControl >
                                <FormControl.Label>Name</FormControl.Label>
                                <FormControl.ErrorMessage _text={{
                                    fontSize: 'xs'
                                }}>
                                    error
                                </FormControl.ErrorMessage>
                                <Input onChangeText={value => setData({
                                    ...formData,
                                    name: value
                                })} />
                            </FormControl>
                            <FormControl>
                                <FormControl.Label>Username</FormControl.Label>
                                <Input type="username" autoCorrect={false} onChangeText={value => setData({
                                    ...formData,
                                    username: value
                                })} />

                            </FormControl>
                            <FormControl>
                                <FormControl.Label>Email</FormControl.Label>
                                <Input type="email" autoCorrect={false} onChangeText={value => setData({
                                    ...formData,
                                    email: value
                                })} />

                            </FormControl>
                            <FormControl>
                                <FormControl.Label>Password</FormControl.Label>
                                <Input type="username" onChangeText={value => setData({
                                    ...formData,
                                    password: value
                                })} />

                            </FormControl>

                            <Button pt="2" colorScheme="indigo" onPress={() => singUp()}>
                                Sign Up
                            </Button>
                            <HStack mt="6" justifyContent="center">
                                <Text fontSize="sm" color="coolGray.600" _dark={{
                                    color: "warmGray.200"
                                }}>
                                    I'm already a user.{" "}
                                </Text>
                                <TouchableOpacity onPress={() => navigation.navigate('home')}>
                                    <Box _text={{
                                        color: "indigo.500",
                                        fontWeight: "medium",
                                        fontSize: "sm"
                                    }} href="#">
                                        Sign In
                                    </Box>
                                </TouchableOpacity>
                            </HStack>
                        </VStack>
                    </Box>

                </Center>
            </Box>
        </NativeBaseProvider>
    );
}